// process.nextTick from node
// Sticks function to bottom of callstack
// Easier to use with args than calling setTimeout directly
export default function nextTick(cb, ...args) {
  setTimeout((...newArgs) => cb(...args, ...newArgs), 0);
}
